import React, { Component } from "react";
import { placeOrder } from "./actions";

class InstantCheckout extends Component {
  handleCheckoutClick = () => {
    const { cartId } = this.props;
    placeOrder(cartId, this.checkoutCallback);
  };

  checkoutCallback = () => {
    window.alert("Your order has been placed. Page will now reload.");
    sessionStorage.removeItem("cartId");
    window.location.reload();
  };

  render() {
    const { handleCheckoutClick } = this;
    return (
      <div className="instantCheckout">
        <button onClick={handleCheckoutClick} className="button button--cta">
          Instant Checkout
        </button>
      </div>
    );
  }
}
export default InstantCheckout;



// WEBPACK FOOTER //
// ./src/components/InstantCheckout/InstantCheckout.jsx